import { queryOptions } from '@tanstack/react-query';

import { getInstrumentOwnershipPageData } from './get-instrument-ownership-page-data.ts';

interface GetInstrumentOwnershipPageDataQueryOptionsInput {
	readonly ticker: string;
}

export function getInstrumentOwnershipPageDataQueryOptions({
	ticker,
}: GetInstrumentOwnershipPageDataQueryOptionsInput) {
	return queryOptions({
		queryFn: () => getInstrumentOwnershipPageData({ data: { ticker } }),
		queryKey: ['instrument-ownership-page-data', ticker] as const,
	});
}
